<template>
  <div>
    <div id="pdfContent" class="text-left"></div>
    <button v-show="showBtn" @click="pdfBilanVente();" target="_blank" class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('click_here_toview_others_colors')}}</button>
  </div>
</template>

<script>
import {getBilanVente} from "../services/Questionnaire.service";

export default {
    name: 'BalanceSheetSale',
    data: () => ({
      windowWidth: 0,
      windowHeight: 0,
      linkPdf: null,
      showBtn: false,
    }),
    methods: {
      pdfBilanVente() {
        window.open(this.linkPdf, '_blank');
      },
      getWindowWidth(event) {
        this.windowWidth = document.documentElement.clientWidth;
      },
      getWindowHeight(event) {
        this.windowHeight = document.documentElement.clientHeight;
      },
      loadHtmlContent() {
        document.getElementById('pdfContent').innerHTML = 'Chargement bilan de vente en cours...';
        if(localStorage.getItem('userId')) {
          this.linkPdf = 'https://www.comcolors.com/fr/cpf-comcolors/';
          const userId = localStorage.getItem('userId');
          getBilanVente(userId).then(response => {
              const resData = response.data
              document.getElementById('pdfContent').innerHTML = resData.html;
              //this.showBtn = true;
          }).catch(error => {
            console.log(error.response);
            document.getElementById('pdfContent').innerHTML = 'Erreur chargement bilan de vente !';
          })
        }

      }
    },
    async mounted() {
      this.loadHtmlContent();
      this.$nextTick(function () {
        window.addEventListener('resize', this.getWindowWidth);
        window.addEventListener('resize', this.getWindowHeight);

        //Init
        this.getWindowWidth()
        this.getWindowHeight()
      })
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.getWindowWidth);
      window.removeEventListener('resize', this.getWindowHeight);
    }
}
</script>

<style lang="css" scoped>
.md-dialog {
  max-width: 587px;
  border: 4px solid #33b5e5;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  box-shadow: 2px 2px 6px rgba(0,0,0,0.6);
}
.start-question {
  margin-right: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/BalanceSheetSale.vue